import { render } from "./MemorialDetailView.vue?vue&type=template&id=263ddb9a"
import script from "./MemorialDetailView.vue?vue&type=script&lang=js"
export * from "./MemorialDetailView.vue?vue&type=script&lang=js"

import "./MemorialDetailView.vue?vue&type=style&index=0&id=263ddb9a&lang=css"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__